import React from 'react';
import { Box, Typography, Button } from '@lucid/lego';
import styles from './Header.module.scss';

type HeaderLabels = {
  orderBuilder?: string;
  orderBuilderDescription?: string;
  submitCart?: string;
};

export type HeaderProps = {
  theme: 'dark' | 'light';
  labels?: HeaderLabels;
  onSubmit: () => void;
};

/**
 * Top header bar for the Checkout page — displays the page title, description, and Submit Cart CTA.
 * @component
 * @param {HeaderProps} props
 * @returns {JSX.Element}
 * @example
 * <Header theme="light" labels={labels} onSubmit={() => {}} />
 */
const Header: React.FC<HeaderProps> = ({ theme, labels, onSubmit }) => (
  <Box className={styles.header}>
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        {labels?.orderBuilder ?? 'Order Builder'}
      </Typography>
      <Typography variant="body" size="medium" color="gray-3" theme={theme}>
        {labels?.orderBuilderDescription ?? 'View your projected forecasting by month and year.'}
      </Typography>
    </Box>
    <Button
      theme={theme}
      size="medium"
      type="primary"
      dataTestId="submit-cart-button"
      gaComponent="order-builder-checkout"
      onClick={onSubmit}
      label={labels?.submitCart ?? 'Submit Cart'}
    />
  </Box>
);

export default Header;
